import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@material-ui/core';
import ActionCTA from '../../../../sharedcomponents/sweepr-action-cta/ActionCTA';
import TroubleshootingIcon from './TroubleshootingIcon';
import { getTileImage, getServiceDetails } from './troubleshooting.util';
import styles from './style';

/**
 * @name TroubleshootingTile - TroubleshootingTile component
 * @param {*} props - Strapi cms data
 * @returns {JSX.Element} - Returns TroubleshootingTile Element
 */
const TroubleshootingTile = props => {
    const theme = useTheme();
    const {
        troubleTileMobile,
        troubleTileDesktop,
        troubleTileTablet,
        troubleTileForegroundDesktop,
        troubleTileForegroundMobile,
        troubleTileForegroundTablet,
    } = getTileImage(props);
    const classes = styles({
        theme,
        troubleTileMobile,
        troubleTileDesktop,
        troubleTileTablet,
        troubleTileForegroundDesktop,
        troubleTileForegroundMobile,
        troubleTileForegroundTablet,
    });
    const subscriptions = JSON.parse(
        sessionStorage.getItem('LoggedinUserSubscriptionIDandAccountID')
    );
    const serviceGroups = [...new Set(subscriptions.map(subs => subs.serviceGroup))];
    const { services } = props?.cmsData;
    const matchedIssue = getServiceDetails(serviceGroups, services);
    const { title, description } = matchedIssue;

    return (
        <Grid
            container
            className={
                props.cmsData?.Tile_images?.length > 0
                    ? classes.TroubleContainer
                    : classes.TroubleCenterAlign
            }
        >
            <Grid
                item
                xs={12}
                sm={props.cmsData?.Tile_images?.length > 0 ? 6 : 12}
                md={props.cmsData?.Tile_images?.length > 0 ? 6 : 12}
                className={
                    props.cmsData?.Tile_images?.length > 0
                        ? classes.TroubleDetails
                        : classes.TroubleCentre
                }
            >
                <Box
                    className={
                        props.cmsData?.Tile_images?.length > 0
                            ? classes.TroubleBox
                            : classes.TroubleBoxCenter
                    }
                >
                    {props.cmsData?.icon?.data && props.cmsData?.Tile_images?.length === 0 && (
                        <TroubleshootingIcon icon={props?.cmsData?.icon} />
                    )}
                    <Box
                        className={
                            props.cmsData?.Tile_images?.length > 0
                                ? classes.TroubleText
                                : classes.TroubleTextAlign
                        }
                    >
                        <Typography component='p' variant='h2' className={classes.TroubleTitle}>
                            {title}
                        </Typography>
                        <Typography
                            component='p'
                            variant='body1'
                            className={classes.TroubleDescription}
                        >
                            {description}
                        </Typography>
                        <Box className={classes.TroubleCTA}>
                            <ActionCTA
                                cta={props?.cmsData?.Tile_CTAs}
                                handleAction={props?.handleAction}
                            />
                        </Box>
                    </Box>
                </Box>
            </Grid>
            {props.cmsData?.Tile_images?.length > 0 && (
                <Grid item xs={12} sm={6} md={6} className={classes.ForegroundImageContainer}>
                    <Box className={classes.ForegroundImage} />
                </Grid>
            )}
        </Grid>
    );
};
TroubleshootingTile.displayName = 'TroubleshootingTile';
export default TroubleshootingTile;
